import { findRootPageDescriptor } from './descriptor.get-root.js';
import { isPartOfMegaMenu } from './descriptor.is-part-of-megamenu.js';
import { findPageDescriptorByPath } from './util.find-page-descriptor-by-path.js';

function findActiveRootPage(state, path) {
  const activePage = findPageDescriptorByPath(state, path);
  if (!activePage) {
    return void 0;
  }
  if (isPartOfMegaMenu(state, activePage)) {
    return void 0;
  }
  return findRootPageDescriptor(state, activePage);
}

export { findActiveRootPage };
//# sourceMappingURL=descriptor.get-active-root.js.map
